import React from "react";
import { Modal, Form, Input } from "antd";
import ReactGA from "react-ga4";

export const ContactXMLAgencyModalInputs = ({
  visible,
  setIsContactXMLAgencyModalShown,
  chat,
  form,
  textFormSubmit
}) => {

  const handleSubmit = (e) => {
    e.preventDefault()
    form.validateFields((err, initialContactInfoValues) => {
      if (!err) {
        textFormSubmit({ initialContactInfoValues })
        setIsContactXMLAgencyModalShown(false)

        ReactGA.event({
          category: "Slanje kontakt podataka XML",
          action: "Click",
          label: "Želi da pošalje podatke"
        });

      }
    });
  };

  const handleCancel = () => {
    setIsContactXMLAgencyModalShown(false)
    textFormSubmit()

    ReactGA.event({
      category: "Slanje kontakt podataka XML",
      action: "Click",
      label: "Ne želi da pošalje podatke"
    });

  }

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      title="Želite li poslati i svoje kontakt podatke?"
      okText="Pošalji kontakt podatke"
      cancelText="Ne želim"
      okButtonProps={{
        disabled: Object.values(form.getFieldsError(["email", "phoneNumber"])).some(Boolean),
        style: {
          padding: "4px 25px",
          fontWeight: "bold",
          height: "54px"
        }
      }}
      cancelButtonProps={{
        style: {
          padding: "4px 25px",
          fontWeight: "bold",
          height: "54px",
          color: "#828282"
        }
      }}
      onOk={handleSubmit}
    >
      <div>
        <p style={{ marginBottom: 24 }}>
          Prodavači često odgovaraju brže ako odmah imaju Vaš e-mail i broj telefona.
          Podatke možete izmijeniti prije slanja.
        </p>

        <Form>
          <Form.Item>
            {form.getFieldDecorator("email", {
              initialValue: chat.senderContactInfo && chat.senderContactInfo.email,
              rules: [
                { required: true, message: "E-mail je obavezan" },
                { type: "email", message: "Unesite ispravnu e-mail adresu" },
              ],
            })(
              <Input placeholder="Unesite e-mail adresu" />
            )}
          </Form.Item>
          <Form.Item>
            {form.getFieldDecorator("phoneNumber", {
              initialValue: chat.senderContactInfo && chat.senderContactInfo.phoneNumber,
              rules: [
                { required: true, message: "Broj telefona je obavezan" },
                { pattern: /^\+?[\d\s\-()]{6,20}$/, message: "Unesite ispravan broj telefona" },
              ],
            })(
              <Input placeholder="Unesite broj telefona" />
            )}
          </Form.Item>
          <p style={{ fontSize: 12, marginBottom: 24 }}>Vaši podaci bit će poslani samo oglašivaču ovog oglasa.</p>
        </Form>

      </div>
    </Modal >
  )
}

export const ContactXMLAgencyModal = Form.create()(ContactXMLAgencyModalInputs)



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/ContactXMLAgencyModal.tsx